import { render, staticRenderFns } from "./sqlOverview.vue?vue&type=template&id=61ab0ab6&scoped=true"
import script from "./sqlOverview.vue?vue&type=script&lang=js"
export * from "./sqlOverview.vue?vue&type=script&lang=js"
import style0 from "./sqlOverview.vue?vue&type=style&index=0&id=61ab0ab6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab0ab6",
  null
  
)

export default component.exports